/* global axios */
import ApiClient from './ApiClient';

class BuhotextCampaignsAPI extends ApiClient {
  constructor() {
    super('buhotext_campaigns', { accountScoped: true });
  }

  send(campaignId) {
    return axios.post(`${this.url}/${campaignId}/send_campaign`);
  }

  stats(campaignId) {
    return axios.get(`${this.url}/${campaignId}/stats`);
  }

  availableDevices() {
    return axios.get(`${this.url}/available_devices`);
  }

  serverInfo() {
    return axios.get(`${this.url}/server_info`);
  }

  createDevice(name) {
    return axios.post(`${this.url}/create_device`, { name });
  }

  updateDevice(deviceId, name) {
    return axios.post(`${this.url}/devices/${deviceId}`, { name });
  }

  deleteDevice(deviceId) {
    return axios.delete(`${this.url}/devices/${deviceId}`);
  }

  getDevice(deviceId) {
    return axios.get(`${this.url}/devices/${deviceId}`);
  }

  sendDirectSMS(
    deviceId,
    simSubscriptionId,
    content,
    phoneNumbers,
    isScheduled,
    scheduledDatetime
  ) {
    const payload = {
      device_id: deviceId,
      sim_subscription_id: simSubscriptionId,
      content: content,
      phone_numbers: phoneNumbers,
    };
    if (isScheduled) {
      payload.is_scheduled = isScheduled;
      payload.scheduled_datetime = scheduledDatetime;
    }
    return axios.post(`${this.url}/send_direct_sms`, payload);
  }

  listSMS(page = 1, resultsPerPage = 25) {
    return axios.get(`${this.url}/list_sms`, {
      params: { page, results_per_page: resultsPerPage },
    });
  }

  getSMS(smsId) {
    return axios.get(`${this.url}/sms/${smsId}`);
  }

  deleteSMS(smsId) {
    return axios.delete(`${this.url}/sms/${smsId}`);
  }

  // Campaigns de 66text API
  listCampaigns(page = 1, resultsPerPage = 25) {
    return axios.get(`${this.url}/list_campaigns`, {
      params: { page, results_per_page: resultsPerPage },
    });
  }

  getCampaign(campaignId) {
    return axios.get(`${this.url}/campaigns/${campaignId}`);
  }

  createCampaign(data) {
    return axios.post(`${this.url}/create_campaign`, data);
  }

  updateCampaign(campaignId, data) {
    return axios.post(`${this.url}/campaigns/${campaignId}`, data);
  }

  deleteCampaign(campaignId) {
    return axios.delete(`${this.url}/campaigns/${campaignId}`);
  }
}

export default new BuhotextCampaignsAPI();
